



import { DiscountParams } from '../../store/interfaces/discount';
import target from './form/target.vue';
import { tCashbackParams } from '@/store/interfaces/cashback';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Rules',
  components: {
    target,
  },
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
      required: true,
    },
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams) {
        this.$emit('update:model', value);
      },
    },
  },
});
